import React, { Component } from 'react';
import { StaticQuery, graphql } from 'gatsby';

import Header from '../Header';
import Footer from '../Footer';
import Notifications from './notifications';

import './style.scss';

class Layout extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        // Update the document title using the browser API
        this.props.actions.userActions.getPlayerData();
        this.props.actions.drawTicketActions.setGameOver();
    }

    render() {
        return (
            <StaticQuery
                query={graphql`
                    query HomeTitleQuery {
                        site {
                            siteMetadata {
                                title
                                mainMenu {
                                    uri
                                    title
                                }
                                footer {
                                    uri
                                    title
                                }
                            }
                        }
                    }
                `}
                render={data => {
                    return (
                        <div className="homeLayout">
                            <Header
                                {...data.site.siteMetadata}
                                actions={this.props.actions}
                                user={this.props.user}
                            />
                            <div className="main">
                                <div className="page-content">
                                    <Notifications
                                        notification={this.props.notification}
                                    />
                                    {this.props.children}
                                </div>
                            </div>
                            <Footer
                                {...data.site.siteMetadata}
                                actions={this.props.actions}
                                user={this.props.user}
                            />
                        </div>
                    );
                }}
            />
        );
    }
}

export default Layout;
